import api from "../Environment";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from '../components/Helper/NotificationMessage';
import store from './index';
import { profileFailure } from "./slices/AdminSlice";

const logout = () => {
  store.dispatch(profileFailure());
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
}

export const getCommonSaga = async ({
  apiUrl,
  payload,
  success,
  failure,
  successCallback = false,
  failureCallback = false,
  successNotify = true,
  errorNotify = true,
}) => {
  try {
    const response = await api.postMethod(apiUrl, payload);
    if (response.data.success) {
      if (successCallback) success(response.data.data);
      else store.dispatch(success(response.data.data));
      if (successNotify) getSuccessNotificationMessage(response.data.message);
    } else {
      if (failureCallback) failure(response.data);
      else store.dispatch(failure(response.data));
      if (errorNotify) getErrorNotificationMessage(response.data.error);
      if (response.data.error_code && response.data.error_code === 401) logout();
    }
  } catch (error) {
    if (failureCallback) failure(error);
    else store.dispatch(failure(error));
    if (errorNotify) getErrorNotificationMessage(error.message);
  }
}

export const commonSagaGetApi= async ({
  apiUrl,
  payload,
  success,
  failure,
  successCallback = false,
  failureCallback = false,
  successNotify = true,
  errorNotify = true,
}) => {
  try {
    const response = await api.getMethod(apiUrl, payload);
    if (response.data.success) {
      if (successCallback) success(response.data.data);
      else store.dispatch(success(response.data.data));
      if (successNotify) getSuccessNotificationMessage(response.data.message);
    } else {
      if (failureCallback) failure(response.data);
      else store.dispatch(failure(response.data));
      if (errorNotify) getErrorNotificationMessage(response.data.error);
      if (response.data.error_code && response.data.error_code === 401) logout();
    }
  } catch (error) {
    if (failureCallback) failure(error);
    else store.dispatch(failure(error));
    if (errorNotify) getErrorNotificationMessage(error.message);
  }
}

export const getTraderCommonSaga = async ({
  apiUrl,
  payload,
  success,
  failure,
  successCallback = false,
  failureCallback = false,
  successNotify = true,
  errorNotify = true,
}) => {
  try {
    const response = await api.traderPostMethod(apiUrl, payload);
    if (response.data.success) {
      if (successCallback) success(response.data.data);
      else store.dispatch(success(response.data.data));
      if (successNotify) getSuccessNotificationMessage(response.data.message);
    } else {
      if (failureCallback) failure(response.data);
      else store.dispatch(failure(response.data));
      if (errorNotify) getErrorNotificationMessage(response.data.error);
      if (response.data.error_code && response.data.error_code === 401) logout();
    }
  } catch (error) {
    if (failureCallback) failure(error);
    else store.dispatch(failure(error));
    if (errorNotify) getErrorNotificationMessage(error.message);
  }
}

export const commonSagaTradedGetApi= async ({
  apiUrl,
  payload,
  success,
  failure,
  successCallback = false,
  failureCallback = false,
  successNotify = true,
  errorNotify = true,
}) => {
  try {
    const response = await api.traderGetMethod(apiUrl, payload);
    if (response.data.success) {
      if (successCallback) success(response.data.data);
      else store.dispatch(success(response.data.data));
      if (successNotify) getSuccessNotificationMessage(response.data.message);
    } else {
      if (failureCallback) failure(response.data);
      else store.dispatch(failure(response.data));
      if (errorNotify) getErrorNotificationMessage(response.data.error);
      if (response.data.error_code && response.data.error_code === 401) logout();
    }
  } catch (error) {
    if (failureCallback) failure(error);
    else store.dispatch(failure(error));
    if (errorNotify) getErrorNotificationMessage(error.message);
  }
}

export const chatCommonSaga = async ({
  apiUrl,
  payload,
  success,
  failure,
  successCallback = false,
  failureCallback = false,
  successNotify = true,
  errorNotify = true,
}) => {
  try {
    const response = await api.chatPostMethod(apiUrl, payload);
    if (response.data.success) {
      if (successCallback) success(response.data.data);
      else store.dispatch(success(response.data.data));
      if (successNotify) getSuccessNotificationMessage(response.data.message);
    } else {
      if (failureCallback) failure(response.data);
      else store.dispatch(failure(response.data));
      if (errorNotify) getErrorNotificationMessage(response.data.error);
      if (response.data.error_code && response.data.error_code === 401) logout();
    }
  } catch (error) {
    if (failureCallback) failure(error);
    else store.dispatch(failure(error));
    if (errorNotify) getErrorNotificationMessage(error.message);
  }
}

 